import React from 'react';
import classNames from 'classnames';
import * as PropTypes from 'prop-types';

import { importStatic } from 'utils';

import classes from './ZpChip.module.css';

const propTypes = {
  display: PropTypes.string.isRequired,
  enable: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  theme: PropTypes.oneOf(['default', 'white']),
};

const defaultProps = {
  enable: false,
  theme: 'default',
};

const ZpChip = (props) => {
  const { display, enable, onClick, theme } = props;
  return (
    <div className={classNames('zp-chip', classes.zpChip)}>
      <div
        className={classNames(`zp-chip-container noSelect ${enable ? 'zp-chip-enable' : ''}`, {
          [classes.whiteChip]: theme === 'white',
        })}
        onClick={onClick}
      >
        <span className="zp-chip-display">{display}</span>
        <img src={importStatic('/ui-router/images/select-x.svg')} className="zp-chip-x" />
      </div>
    </div>
  );
};

ZpChip.propTypes = propTypes;
ZpChip.defaultProps = {
  enable: false,
};

export default ZpChip;
